import Select, { Props as ReactSelectProps } from 'react-select'
import { GroupBase } from 'react-select'

type CustomSelectProps<Option = unknown, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> = ReactSelectProps<Option, IsMulti, Group>;

export const CustomSelect = <
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(
    props: CustomSelectProps<Option, IsMulti, Group>
) => {
    return (
        <Select
            isClearable={true}
            components={{
                ClearIndicator: () => null,
            }}
            {...props}
        />
    );
};

export default CustomSelect;